var exports = {
  "C": "TextAreaElementContainer__nwQBxl",
  "v": "codeViewTextArea__oYyB9G",
};

module.exports = exports;
